import { Injectable } from '@angular/core';
import { Filesystem } from '@capacitor/filesystem';
import { Camera, CameraDirection, CameraResultType, ImageOptions } from '@capacitor/camera';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class CameraService {
    private readonly cameraOptions: ImageOptions = {
        quality: 70,
        direction: CameraDirection.Rear,
        allowEditing: false,
        resultType: CameraResultType.Uri,
    }

    constructor(
        private domSanitizer: DomSanitizer,
    ) { }

    async takePhoto(): Promise<CameraResult | null> {
        const image = await Camera.getPhoto(this.cameraOptions);
        if (!image) return Promise.resolve(null);
        const readFileResult = await Filesystem.readFile({ path: image.path! });
        const cameraResult: CameraResult = {
            blob: this.base64ToBlob(readFileResult.data as string),
            sanitizedUrl: this.sanitizeUrl(image.webPath!)
        };

        return Promise.resolve(cameraResult);
    }

    private base64ToBlob(base64Image: string): Blob {
        const rawData = atob(base64Image);
        const bytes = new Array(rawData.length);
        for (let i = 0; i < rawData.length; i++) {
            bytes[i] = rawData.charCodeAt(i);
        }
        const arr = new Uint8Array(bytes);
        return new Blob([arr], { type: 'image/jpg' });
    }

    private sanitizeUrl(imageUri: string): string {
        return this.domSanitizer.bypassSecurityTrustUrl(imageUri) as string;
    }
}

export interface CameraResult {
    blob: Blob;
    sanitizedUrl: string;
}